/**
 * GENERATED by scripts/gen-acquisition-routes.mjs from src/data/acquisition.
 * Do not edit by hand. App.tsx maps these to routes; the page copy stays in
 * each page's lazy chunk. src/data/acquisition/__tests__ holds this list
 * equal to the registry.
 */
export const ACQ_MANIFEST: { path: string; component: string }[] = [
  { path: "/tools", component: "hub" },
  { path: "/demos", component: "hub" },
  { path: "/switch", component: "hub" },
  { path: "/use-cases", component: "hub" },
  { path: "/integrations", component: "hub" },
  { path: "/research", component: "hub" },
  { path: "/tools/receptionist-cost-calculator", component: "cost-calculator" },
  { path: "/tools/missed-call-report", component: "missed-call-report" },
  { path: "/tools/setup-simulator", component: "setup-simulator" },
  { path: "/tools/call-script-builder", component: "script-builder" },
  { path: "/demos/after-hours", component: "after-hours" },
  { path: "/demos/follow-a-call", component: "follow-a-call" },
  { path: "/demos/your-business", component: "your-business" },
  { path: "/demos/booking-an-appointment", component: "demo-question" },
  { path: "/demos/emergency-call", component: "demo-question" },
  { path: "/demos/price-question", component: "demo-question" },
  { path: "/demos/reaching-a-person", component: "demo-question" },
  { path: "/demos/caller-corrects-details", component: "demo-question" },
  { path: "/demos/job-it-cannot-book", component: "demo-question" },
  { path: "/challenge", component: "challenge" },
  { path: "/card", component: "card" },
  { path: "/switch/from-smith-ai", component: "guide" },
  { path: "/switch/from-goodcall", component: "guide" },
  { path: "/switch/from-answering-service", component: "guide" },
  { path: "/use-cases/after-hours-plumbing-calls", component: "use-case" },
  { path: "/use-cases/hvac-overflow-calls", component: "use-case" },
  { path: "/use-cases/dental-lunch-hour-coverage", component: "use-case" },
  { path: "/integrations/call-forwarding", component: "guide" },
  { path: "/integrations/google-calendar", component: "guide" },
  { path: "/integrations/outlook-calendar", component: "guide" },
  { path: "/integrations/zapier-and-webhooks", component: "guide" },
  { path: "/tampa/storm-communications-kit", component: "storm-kit" },
  { path: "/tampa/business-phone-guide", component: "guide" },
  { path: "/research/ai-answers", component: "ai-answers" },
  { path: "/partners", component: "partners" },
  { path: "/partners/advisors", component: "advisors" },
  { path: "/build-in-public", component: "build-series" },
];

/** The live hub pages, for the site footer (small enough for the first load). */
export const ACQ_HUB_LINKS: { path: string; label: string }[] = [
  { path: "/tools", label: "Free tools" },
  { path: "/demos", label: "Demos" },
  { path: "/switch", label: "Switching guides" },
  { path: "/use-cases", label: "Situations" },
  { path: "/integrations", label: "Integration guides" },
  { path: "/research", label: "Research" },
];
